import { render, staticRenderFns } from "./GeneralUserLayout.vue?vue&type=template&id=babd2b84&"
import script from "./GeneralUserLayout.vue?vue&type=script&lang=js&"
export * from "./GeneralUserLayout.vue?vue&type=script&lang=js&"
import style0 from "./GeneralUserLayout.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports